import React, { useState } from 'react';
import { Card, CardHeader, CardBody, CardFooter, Row, Col, Button, Tooltip } from "reactstrap";

export default function CardOpcaoCadastro({ opcao, handleClickOpcao, indice }) {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    return (
        <>
            <Col lg="4" md="6" sm="6">
                <Card className="card-stats card-box">
                    <div className="w-100 d-flex justify-content-end pt-1 pr-2 " >
                        <span
                            id={"tooltip-" + indice}
                            className=" me-4 p-1 d-flex justify-content-center align-items-center"
                            style={{ borderRadius: '100%', width: '30px', height: '30px', border: '3px solid #666', fontSize: '16px', fontWeight: 'bold', color: '#666' }}>
                            ?
                        </span>
                    </div>
                    <CardHeader className="text-center titulo-card pr-2">
                        {opcao.descricao.includes("RSS") ? opcao.segmento.replace("Grande", "") : opcao.segmento}
                        <br />
                        <small>{opcao.descricao }</small>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md="12" xs="12" >
                                <div className={"icon-lg text-center " + opcao.corIcone}>
                                    <i class={opcao.classeIcone}></i>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter className="text-center mt-2">
                        <hr />
                        <Button color="success" onClick={() => handleClickOpcao()}>Cadastre-se</Button>
                    </CardFooter>
                </Card>
                <Tooltip
                    isOpen={tooltipOpen}
                    placement="top"
                    target={"tooltip-" + indice}
                    toggle={() => { setTooltipOpen(!tooltipOpen) }}
                >
                    {opcao.detalhes}
                </Tooltip>
            </Col>
        </>
    );
}